module.exports = __webpack_public_path__ + "static/img/top.b618209.png";


//////////////////
// WEBPACK FOOTER
// ./static/top.png
// module id = yWBV
// module chunks = 1